module.exports = __webpack_public_path__ + "landing-header.c67d8d352a4b776452fa.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/images/landing/landing-header.png
// module id = ../../../../../src/assets/layout/images/landing/landing-header.png
// module chunks = 2